const state = {
  jobsList: [
     // Bioscience
     {
      department: 'Bioscience',
      list: [
        {
          name: 'Cell Group Scientist',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Design experiments independently"},
            {dec: "Implement, validate and optimize experimental methods"},
            {dec: "Analysis and manage data"},
            {dec: "Interpret results, prepare reports and present findings"},
            {dec: "Remain current in research area and discovery program"},
            {dec: "Act in accordance with all company policies on personnel, SHE, etc."},
          ],
          requirement: [
            {
              dec: "Minimum Requirements –Education and Experience",
              addition:[
                "Typically 5 or more years’ experience post Master’s Degree or equivalent"
              ]
            },
            {
              dec: "Skills and Capabilities",
              addition:[
                "Well-developed understanding of theoretical aspects of discipline and a high level of ability in experimental techniques.",
                "Regularly demonstrates capacity to apply literature and theoretical concepts to the advancement of project goals.",
                "Strong knowledge and understanding of relevant database and analytical software.",
                "Independent planning, execution and interpretation of experiments that contribute significantly to project goals.",
                "Able to develop logical positions and convince others.",
                "Consistently generates high quality results within established time frames.",
                "Strong problem solving skills and the ability to, on the basis of their own experience and analytical skills, initiate the use of new techniques and to ascertain their value in solving problems relating to their immediate project.",
                "Collect, analyze, and summarize data for reports and patents, and present data at project and/or team meetings. ",
                "Deliver presentations that are well thought out, informative and convincing.  Able to present work at internal meetings and external meetings when appropriate.  ",
                "Communicate effectively with colleagues at all levels, showing well-developed verbal and written communication skills, coupled with an ability to listen, resulting in clear and succinct messages and accurate interpretation of feedback.",
                "Communicates relevant information from meetings or literature to colleagues.",
                "The ability to manage multiple tasks efficiently. ",
              ]
            },
            {
              dec: "Others",
              addition:[
                "Reliable, S work ethic, and respect others. ",
                "Commitment to team goals.",
                "Willingly shares expertise and ideas and is viewed as a resource by colleagues. ",
                "Demonstrated flexibility, open-mindedness, and adaptability.",
                "Act in accordance with all company policies on personnel, SHE, best laboratory practice, etc.",
                "Self-motivated to expand personal skills and knowledge as required to be effective.",
                "Projected creditability and professionalism",
                "Foster environment of scientific excellence, innovation, productivity and timeliness by example.",
              ]
            },

          ] 
        },
        {
          name: 'Immuno-Oncology Scientist',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Independently design and execute biology studies in vitro and ex vivo within timelines to characterize target of interest function, pathway modulation, and cell sensitivity."},
            {dec: "Develop immune functional cell-based assays using extensive immunology technologies (e.g. primary human and mouse lymphocytes, myeloid cell activation and differentiation, cytokine assays, multiple color flow cytometry)"},
            {dec: "Develop, trouble-shoot, and optimize relevant cell-based assay systems, technologies, and readouts to support various projects outside of his/her own and collaborate with partners from all relevant functions. "},
            {dec: "Participate in development projects, particularly in collaboration with colleagues from different functions whenever the company required."},
            {dec: "Publish experimental findings in top-tier journals and present novel findings at leading scientific conferences."},
          ],
          requirement: [
            {dec: "Ph.D. in Immunology or related field, MS in Immunology or relevant discipline with 5+ year (or equivalent) in biomedical or pharmaceutical research. "},
            {dec: "Strong knowledge and technical expertise in immunology and oncology research with demonstrated ability to perform and develop in vitro/ex-vivo assays."},
            {dec: "Technical skills include isolation and culturing of multiple immune cells and cancer cells, MLR (mixed lymphocyte reaction), T cell activation and proliferation assays, immunoblotting, Luminex, multiparameter flow cytometry assay, etc."},
            {dec: "Should be willing to adapt to learn new science concepts and techniques and apply knowledge to new targets and research fields."},
            {dec: "Strong verbal and written communication skills. Ability to collaborate and troubleshoot to solve problems."},
            {dec: "Organized, goal-oriented and timeline-conscious"},
          ] 
        },
      ]
    },
    {
      department: 'Biologics',
      list: [
      {
        name: 'Cell Biologist',
        loLocation: 'Shanghai',
        roleResponsibility: [
          {dec: "Skilled in cell culture, cell transfection, ELISA, FACS, WB assays"},
          {dec: "Expertise with flow cytometry, cytokine release, cytotoxicity and proliferation assays are strongly preferred."},
          {dec: "He/she is able to follow existent in vitro assay SOP and repeat the assay results within acceptable variation. "},
          {dec: "Perform and monitor routine experiments to support multiple project requirement."},
          {dec: "Based on project needs, He/she can develop reasonable and repeatable new procedure. "},
          {dec: "Coach or involve in transgenic stable cell line "},
          {dec: "Evaluate the bioactivity of molecules and elucidate the mechanism by performing required molecular and cellular assays. "},
          {dec: "Support partial animal related experiments"},
          {dec: "Align with the overall goals of the team and support multiple project-relevant area."},
          {dec: "Prepare documents to support IND-filing to FDA/CFDA."},
        ],
        requirement: [
          {dec: "5 years' experience with bachelor's degree or 3 year's Master on biology  "},
          {dec: "Hands on experience in antibody/protein expression and purification, Ig based biochemical and biophysical assay development."},
          {dec: "Previous experience in drug development in pharmaceutical and /or biotech environment is preferred. "},
          {dec: "Fluent communication skill (both written and oral English) and ability to articulate scientific results are a must. "},
          {dec: "Detail-oriented, with excellent organizational and record-keeping skills and capability to multi-task is essential."},
          {dec: "Proven track record of scientific productivity is plus. "},
          {dec: "Excellent verbal and written communication skills and good enough English, fluent in English reading/writing/listening/speaking"},
          {dec: "Comply with National and local regulations and requirements, Dizal policies and lab safety procedures (SHE)"},
        ]
      }
    ]
    },
    /*Drug Safety
    {
      department: 'Drug Safety',
      list: [
      // Toxicologist
      {
        name: 'Toxicologist',
        loLocation: 'Shanghai',
        roleResponsibility: [
          {dec: "Be responsible for leading compound non-clinical toxicology research."},
          {dec: "Work with internal departments to design and conduct toxicology studies, and draft reports."},
          {dec: "Work with CRO to design, coordinate and conduct toxicology studies. Analyze data and review reports."},
          {dec: "Draft IND and NDA filling files."},
        ],
        requirement: [
          {dec: "At least 3-year experience of GLP toxicity studies in CRO or Pharma"},
          {dec: "Familiar with CFDA/ICH/OECD Guidelines"},
          {dec: "Master degree in toxicology, pharmacology, or other related fields"},
          {dec: "Good written and oral English"},
          {dec: "Good team spirit"},
        ]
      },
      ]
    }, */
    // DMPK
    {
      department: 'DMPK',
      list: [
      // DMPK (Sr.) Scientist
      {
        name: 'DMPK Sr. Scientist/Investigator ',
        loLocation: 'Shanghai',
        roleResponsibility: [
          {dec: "Design, outsource and manage non-GLP and GLP DMPK and toxic-kinetic (TK) studies in support of projects from discovery to early development, and write regulatory documents and package towards IND and NDA (e.g. IND, IMPD, IB and NDA)"},
          {dec: "Perform TK/PK analysis and prepare and review study protocols/reports related to DMPK and toxicology studies and interpret study results from toxicology in conjunction with DMPK and pharmacology studies to estimate therapeutic index."},
          {dec: "Perform hands-on experiments of in vitro and in vivo samples in support of discovery and development programs "},
          {dec: "Implementing and monitoring of bioanalytical assay for PK and PD, clinical PK calculation and metabolite profiling/identification/characterization for discovery and clinical development programs."},
          {dec: "Present project DMPK information in meetings and communications at interdisciplinary project teams"},
          {dec: "Participate in development projects, particularly in collaboration with clinical pharmacology, safety assessments and formulation whenever the company required."},
        ],
        requirement: [
          {dec: "M.S. and above; major in Pharmaceutical Sciences, Biochemistry, Medicinal Chemistry or a related field with >1 year working experience;"},
          {dec: "Possessing excellent learning ability, good communication and cooperation skills, scientific literacy and problem-solving capability"},
          {dec: "Ability for critical thinking and strong analytical skills to evaluate complex information for the identification of key scientific findings related to projects."},
          {dec: "Ability to prioritize and manage multiple projects and activities while meeting tight deadlines"},
          {dec: "Maintains excellent working relationships with colleagues and collaborators"},
          {dec: "Hands-on experience in WinNolin for PK parameter calculation is plus"},
          {dec: "Strong communication in English is desirable"},
        ]
      },
      ]
    }, 
    // Clinical Development
    {
      department: 'Clinical Development',
      list: [
        {
          name: 'Clinical Pharmacologist',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Represent Clinical Pharmacology on development project teams"},
            {dec: "Accountable for planning and delivery of scientifically robust and efficient clinical pharmacology strategies for development candidates and strategy"},
            {dec: "Define regulatory strategy for ClinPharm and prepare ClinPharm contributions to regulatory documents including IBs, IND's, briefing books, submission packages, responses to health authority questions, and other regulatory documents. "},
            {dec: "Contribute to the development of clinical study concepts and protocols, clinical study reports, and relevant components of regulatory submission documents"},
            {dec: "Provide input on preclinical-stage programs to optimize in vitro and preclinical data supporting the advancement of programs into clinical development and the submission of Investigational New Drug applications."},
          ],
          requirement: [
            {dec: "PharmD or PhD with 2-5 yrs experience in pharmaceutical industry in clinical pharmacology, clinical pharmacokinetics or drug metabolism or Master with 4-8 yrs working experience "},
            {dec: "Solid knowledge of pharmacokinetics, its clinical application and regulatory context"},
            {dec: "Knowledge and experience in use of PK and PKPD modeling applied to life sciences"},
            {dec: "Demonstrated ability to successfully manage the clinical pharmacology/pharmacokinetic components of multiple drug products across all phases of development"},
            {dec: "Demonstrated capability to mentor junior scientists and manage in a matrix environment"},
            {dec: "Fluent in spoken English and good in written"},
          ] 
        },
        {
          name: 'PV Operation (Sr.) Specialist',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Coordinating and supervising all PV activities in clinical trials to ensure regulatory compliance, including but not limited to PV vendor management, contributing to preparation and submission of expedited safety reports, supporting preparation and review of safety related documents, collaborating on project issue identification and resolution."},
            {dec: "Ensure collection and reporting of product safety events in post-marketing settings in good quality and in compliance with governing laws and legislations, e.g., spontaneously from HCP and consumers, literatures, product complaint, social media, regulatory authorities, organized data collection programs, etc."},
            {dec: "Coordinate preparation and submission of aggregated safety reports, DSUR, PUSR/PEBRE, etc."},
            {dec: "Contribute to identification, evaluation and management of safety signals in collaboration with Safety Physician /Scientist, Study Physician, Drug Safety colleagues and other applicable functional specialists."},
            {dec: "Contribute to the development of safety surveillance and risk management plans for drug development programs."},
            {dec: "Support internal and external PV audits or inspection."},
            {dec: "Perform PV trainings to relevant personnel according to the safety activities assigned."},
            {dec: "Contribute in negotiations with business partners on pharmacovigilance agreements; Interface with business partners as needed in accordance with applicable pharmacovigilance agreements."},
            {dec: "Support PV head on the PV capability establishment, including but not limited to the PV procedure and SOPs establishment, etc."},
          ],
          requirement: [
            {dec: "Bachelor's level degree or above in life sciences, pharmacy, nursing or medical"},
            {dec: "Minimum 2 years experiences in safety operation"},
            {dec: "Familiar with PV processes and safety management in clinical study and/or post-marketing phase"},
            {dec: "Thorough understanding of the regulations and guidance applicable to PV"},
            {dec: "Prior international pharmaceutical company/CRO experience preferred "},
            {dec: "Experience in PV database management or audits/inspections is a plus"},
            {dec: "Excellent organizational skills, learning skills and ability to prioritize and multi-task "},
            {dec: "Excellent communication and interpersonal skills "},
            {dec: "Fluent in English (writing and speaking)"},            
          ]
        },
        {
          name: 'Regulatory Affairs Associate Director/Sr. Manager',
          loLocation: 'Beijing & Shanghai',
          roleResponsibility: [
            {dec: "Develop regulatory submission plans in conjunction with key stakeholders to achieve rapid approval for clinical studies and market authorization, deliver high quality approval and facilitate rapid launch for responsible pipeline (new molecules, indications and line extensions)"},
            {dec: "Track status and take prompt corrective measures whenever necessary"},
            {dec: "Develop regulatory submission forecast"},
            {dec: "Communicate with regulatory agencies/institutes and internal departments on product registration issues"},

            {dec: "Develop regulatory strategy in conjunction with key stakeholders under supervision"},
            {dec: "To be responsible for interactions and negotiations with regulatory bodies in major countries"},
            {dec: "Ensure information sharing and consistency of approach in regulatory advice and awareness across the department and teams"},
            {dec: "Identify regulatory risks and challenges, and develop strategies and backup plans to address issues proactively"},
            {dec: "Ensure product registration and perform regulatory affair activities under Dizal's policies and standard operating procedures, and other product laws and regulations"},

            {dec: "Monitor and understand the impact of external changes in the regulatory and political environment in major markets, that will impact on the assigned products"},
            {dec: "Communicate the impact of changes with key stakeholders"},
            {dec: "Influence key external stakeholders, in line with codes of conduct, to improve regulatory outcomes"},

            {dec: "Monitor and evaluate the new regulations/guidance, regulatory changes/trends, and communicate with internal stakeholders"},
            {dec: "Build up Company good image through high professional standard of application, response to enquiries etc."},
            {dec: "Establish good relationships with regulatory authorities through regular contacts and sponsorship for academic initiatives or trainings"},
            {dec: "Develop internal SOP as needed"},
            {dec: "Collaborate with related functions and provide input and advice on the development new product plan in terms of regulatory requirement"},
          ],
          requirement: [
            {dec: "Bachelor's degree on medical, pharmacy, pharmacology, biochemistry or chemistry"},
            {dec: "Master is plus"},
            {dec: "Possess a high degree of honesty with a track record built on success stories and sound ethics, have a proven track record from a pharmaceutical company"},
            {dec: "Understand the current regulatory practices and regulation in major countries, the authority structure and relationship among different regulatory bodies"},
            {dec: "Strong ability on building solid trust partnerships among peers"},
            {dec: "Excellent verbal and written communication skills and good enough English, fluent in English reading/writing/listening/speaking"},
            {dec: "Able to work with a keen sense of urgency and priority, task oriented with a “Big Picture” approach"},
            {dec: "Good project management skill and experience"},
            {dec: "Minimum 8-year working experience in regulatory affairs function, preferred in global leading pharmaceutical company"},
            {dec: "NDA submission experience of oncology medicine is plus"},
            {dec: "Excellent verbal and written communication skills and good enough English, fluent in English reading/writing/listening/speaking"},
            {dec: "Good at PC skills on Word, Excel, PowerPoint, Outlook, MS Project"},   
          ]
        },
        {
          name: 'Statistical Programmer',
          loLocation: 'Beijing & Shanghai',
          roleResponsibility: [
            {dec: "Work with Clinical Physician, Biostatistician and external vendors when applicable to support the programming activities in clinical trials for Dizal products"},
            {dec: "Develop and/or implement SAS programs to produce SDTM, analysis datasets, Tables, Listings and Graphs in clinical trials for Dizal products"},
            {dec: "Lead or assist in statistical programming deliverables for one or more clinical studies"},
            {dec: "Assist in the review of key study-related documents produced by other functions, e.g. SAP, case report form, data management plan, database specifications, EDC data structures, DMC plans and other clinical documents"},
            {dec: "Follow CDSIC Implementation Guide to review and confirm dataset specifications and eCRF annotations for creation of SDTM datasets"},
            {dec: "Follow CDSIC Implementation Guide to review and confirm dataset specifications for creation of ADaM datasets"},
            {dec: "Develop programs to produce SDTM, ADaM, tables, listings and graphs according to specifications"},
            {dec: "Implement QC validation in accordance with internal SOPs and WIs, and industry regulatory requirements"},
            {dec: "Contribute to the study programming activities. Manage and maintain programs, programming documents and deliverables"},
            {dec: "Provide timely, accurate, and adequate responses and inputs for internal and external inquiries or ad-hoc analyses"},
          ],
          requirement: [
            {dec: "M.S. in Statistics or related discipline with a minimum 3 years of statistical programming work experience in Pharmaceutical, Biotech, or CRO"},
            {dec: "Working knowledge of statistical and data processing software, e.g., SAS and/or R"},
            {dec: "Experience with pharmaceutical industry data standards, such as CDISC/SDTM and ADaM data models"},
            {dec: "Knowledge of statistical concepts, such as p-values, rates and proportions, frequencies, confidence intervals, especially survival analysis. Capable of implementing these ideas in clear, efficient SAS code for the purpose of data analysis and reporting"},
            {dec: "Good verbal and written communication skills"},
            {dec: "Good attention to detail to ensure accuracy and reliability of results; builds and monitors quality in every work activity"},
            {dec: "Proactive and motivated. Ability to learn"},
          ]
        },
        {
          name: 'GCP Quality Assurance Leader',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Leads on key strategic business initiatives from a compliance perspective and accountable for deployment of an effective compliance program"},
            {dec: "Accountable for proactive advisory services on quality and compliance issues"},
            {dec: "Provides effective compliance reporting to senior management. Manages significant compliance incidents and investigations as required"},
            {dec: "Develops and Implements quality and compliance vision and strategy based on comprehensive risk assessment and quality principles that are drawn from expert knowledge of internal and external QA arena focusing on GCP"},
            {dec: "Implements and maintains an effective compliance program involving assurance activities, compliance advice and risk evaluation for area of compliance focus driven from expertise in GCP compliance area"},
            {dec: "Participates in assurance activities to assess operational execution of processes and audit strategy"},
            {dec: "Operationally manages and executes “second line of defence” accountabilities (including conduct of quality assurance assessment activities, support for auditing, investigations, assurance reporting, inspections, etc.)"},
            {dec: "Set operational compliance objectives to ensure embedded and streamlined approach to assurance and contributes to overall QA strategy for GCP QA area"},
            {dec: "Accountable for the standard of audits"},
            {dec: "Supports driving and embedding a culture of ethics and integrity"},
            {dec: "Provides lead support for inspections"},
            {dec: "Provides coaching to staff to support effective delivery of quality assurance services"},
            {dec: "Execute assurance and advisory strategies for assigned GCP area in conjunction with basic level of assessment for business compliance, privacy, and computer systems validation."},
            {dec: "Communicates effectively with compliance colleagues and customers and maintains robust knowledge of relevant industry information affecting compliance arena"},
            {dec: "Compliance with all applicable global and local policies and standards"},
          ],
          requirement: [
            {dec: " Qualified professional - compliance, law, regulations related to area of accountability"},
            {dec: "Significant experience in pharmaceuticals or a related industry"},
            {dec: "Knowledge and experience of corporate governance, health care regulations, laws and standards"},
            {dec: "Excellent analytical, written and oral communications skills"},
            {dec: "Strong collaborative, partnering, and interpersonal skills"},
            {dec: "Strong ability to work independently"},
            {dec: "High ethical standards, trustworthy, operating with absolute discretion"},
            {dec: "Fluent in written and spoken English"},
          ]
        }
      ]
    },
    // Clinical Operations
    {
      department: 'Clinical Operations',
      list: [
        // Regional Project Manager
        {
          name: 'Clinical (Sr.) Project Manager',
          loLocation: 'Shanghai/Beijing',
          roleResponsibility: [
            {dec: "Contribute and support global study lead on overall study deliveries. Ensures the processes for Study Delivery are executed through the development of study reports tools, facilitation of the study delivery system and maintenance of the system which including but not limited to Central lab, Central imaging, Central ECG, IXRS, ePRO etc."},
            {dec: "As an expert, ensures delivery of a centrally managed study management service across clinical studies from start up to reporting. Establish and maintain interactions with key stakeholders including the facilitation of communications with countries, Strategic Partners, Academic clinics and investigational study sites, as appropriate, and external service providers (Third Party Vendors) to identify and resolve operational feasibility issues, facilitate study start-up activities, and ensure Operations deliverables to time, budget and quality objectives."},
            {dec: "To lead study activity at regional level to deliver committed components of clinical studies according to agreed resources, budget and timelines complying with DZ Procedural Documents, international guidelines such as ICH-GCP as well as relevant local regulations.  Develop and maintain excellent working relationships with external and internal customers to ensure the smoothly and timely delivery of clinical studies."},
            {dec: "Initiates, maintains and where applicable contributes to the production of study/essential documents, ensuring template and version compliance."},
            {dec: "Manages and coordinates tracking of study materials and equipment."},
            {dec: "Monitors administrative tasks during the study process, audits and regulatory inspections, according to company policies ."},
            {dec: "Monitor study conduct and progress, proactively identifying to and resolving issues by closely working with global study leader which may impact delivery of the study or to the necessary quality, timeline or budget objectives."},
            {dec: "Ensure local Serious Adverse Event (SAE) reconciliation takes place and any deviations are appropriately documented and reported to Health authorities/Ethics committee."},
            {dec: "Keeps own knowledge of best practices and new relevant developments up to date."},
            {dec: "Provide input towards process improvements."},
            {dec: "Work closely with Quality Management & Quality Assurance to review audit findings and implement effective corrective action plans."},
            {dec: "Ensures completeness and timeliness of the eTMF to maintain it “Inspection Ready”."},
            {dec: "Assists Local study leader/CRA in forecasting study timelines, resources, recruitment, study materials and drugs."},
            {dec: "Provides direction to Local study leader/CRA on major study commitments including resolving any key issues identified."},
            {dec: "Ensure completeness and timeliness of the eTMF to maintain it “Inspection Ready”."},
            {dec: "Identifies opportunities to improve the methodology and provide practical solutions for clinical development"},
            {dec: "Identify and report quality issues along with corrective and preventive actions to Global study leader/equivalent esp when its related to any data privacy, serious breaches and/impact to the reputation of company and safeguard patients' rights and wellbeing."},
          ],
          requirement: [
            {dec: "Bachelor's degree in relevant discipline"},
            {dec: "Minimum 5 years experience in clinical research, at least 2 years experence in international company taking project management role."},
            {dec: "Excellent knowledge of spoken and written English"},
            {dec: "Knowledge of relevant legislation and new developments in the area of Clinical Development and Study Management"},
            {dec: "Demonstrates ability and willingness to work and lead cross-functionally, e.g. with internal and external partners, on global studies"},
            {dec: "Good understanding of clinical data flow"},
            {dec: "Demonstrates ability to prepare and deliver study related training materials"},
            {dec: "Demonstrates ability to plan, coordinate, and facilitate internal and external meetings"},
            {dec: "Demonstrated Project Management skills (e.g. leading delivery team)"},
            {dec: "Excellent mentoring skills and ability to develop others"},
            {dec: "Proven ability to prioritize and manage multiple tasks with conflicting deadlines"},
            {dec: "Excellent interpersonal skills and proven ability to facilitate team building and team workd."},
          ] 
        },

        // Global Study Associate
        {
          name: 'Global Study Associate',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Contribute to clinical study start-up, execution, close-out and reporting activities"},
            {dec: "Collect, review and track regulatory and other relevant documents. Interface with internal staff during the collection process to support effective delivery of a study and its regulatory documents through finalization of the Clinical Study Report (CSR) "},
            {dec: "Initiate and lead the set-up of the electronic Trial Master File (eTMF) including tracking of documents. Maintain and close the eTMF ensuring International Conference of Harmonisation Guidelines for Good Clinical Practice (ICH/GCP) compliance"},
            {dec: "Initiate and lead the set-up of the electronic Clinical Trial Management System (CTMS) at study/country/site level. Maintain and close the CTMS ensuring ICH/GCP compliance. "},
            {dec: "Initiate and maintain production of study documents, ensuring template and version compliance "},
            {dec: "Maintain documents according to current process ensuring compliance with the company policy & SOP"},
            {dec: "Plan and proactively collate the administrative appendices for the CSR Provide input into non-drug project work including training activities, meeting events and development of work instruction as needed"},
            {dec: "Set-up, populate and accurately maintain information in Dizal tracking and communication tools and support others in the usage of these systems "},
            {dec: "Manage and contribute to coordination and tracking of study materials, equipment and study cost."},
            {dec: "Coordinate administrative tasks during the study process, audits and regulatory inspections, according to company policies and SOPs"},
            {dec: "Lead the practical arrangements and contribute to the preparation of internal and external meetings e.g. study team meetings, monitor meetings, Investigator meetings. Liaise with internal and external participants and/or vendors"},
            {dec: "Prepare, contribute to and distribute presentation material for meetings, newsletters and web-sites"},
            {dec: "If needs arise, support LSTL and monitors as the Clinical Trial Assistant at country/site level. "},
            {dec: "Ensure compliance with company policies and procedures relating to people, finance, technology, security and SHE (Safety, Health and Environment)."},
            {dec: "Ability to understand the impact of technology on projects and to use and develop computer skills while making appropriate use of systems/software"},
            {dec: "Identify and report quality issues along with corrective and preventive actions to Local study leader/equivalent esp when its related to any data privacy, serious breaches and/impact to the reputation of company and safeguard patients' rights and wellbeing."},
          ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Level of education that supports Skills and Capabilities of the position and ensures successful conduct of accountabilities/responsibilities and appropriate interactions with internal/external customers",
              ]
            },
            {
              dec: "Experience",
              addition: [
              "Proven organizational and analytical skills",
              "Previous administrative training/experience"
              ]
            },
            {
              dec: "Technical / Skills Training",
              addition: [
                "Develop working knowledge of the Clinical Study Process and an understanding of the range of working procedures relating to it, together with an understanding of the ICH/GCP guidelines",
                "Ability to develop advanced computer skills to increase efficiency in day-to-day tasks",
                "Excellent verbal and written communication and presentation skills",
                "Demonstrate ability to work independently, as well as in a team environment",
                "Ability to prioritise and manage multiple tasks with conflicting deadlines",
                "Good interpersonal skills and ability to work in a team environment",
                "Willingness to travel both domestically and internationally",
                "Proactively identify risks and possible solutions",
                "Develop knowledge of therapy area through experience and review of scientific literature",
                "Ability to prepare presentation materials ",
                "Demonstrate professionalism and mutual respect ",
                "Willingness and ability to train others on study administration procedures",
                "Display excellent organization and time management skills, excellent attention to detail, and ability to multi-task in a high-volume environment with shifting priorities",
                "Computer proficiency",
                "Excellent knowledge of spoken and written English"
              ]
            },
          ] 
        },
        // (Sr.) Quality Control Manager
        {
          name: '(Sr.) Clinical Training & Compliance Manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Oversees the development and implementation of Quality Control strategy and activities for Clinical Operation team. Oversees generation, review and compliance of developed and approved procedures with company-wide quality policies and standards. "},
            {dec: "Responsible for the development, maintenance and the communication of high quality standards in the delivery of clinical studies.  "},
            {dec: "Secures and improves quality in Clinical Operation by providing training, implementing QC activities and driving quality initiatives. "},
            {dec: "Provides compliance and process advice to study teams and identifies opportunities for quality and process improvements.   "},
            {dec: "Responsible for the development, implementation and continuing review of  procedural documents, and maintains current knowledge and understanding of regulations and industry practices in relation to clinical trials."},
            {dec: "Supports audits and inspections and is the main contact for auditors from Clinical Operation team.  Advises and monitors Clinical Operation team in the planning and implementation of all quality control activities and uses risk management to evaluate compliance issues and develop solutions."},
            {dec: "Provide co-monitoring visit according to the alignment with study lead."},
            {dec: "Ensures annual study and system QC plan in place, facilitates and monitors the implementation of QC activities by Clinical Operation team. "},
            {dec: "Analyses quality status of the function, identifies risk/root cause and comes up with CAPA"},
            {dec: "Advises Clinical Operation team on CRO quality management"},
            {dec: "Advises/Supports the local study team in the preparation for, conduct of and responses to audits and regulatory inspections."},
            {dec: "Advises local study team in the resolution of the findings in audit and inspection reports. Gives regular feedback/training on audit and inspection findings to Clinical Operation team."},
            {dec: "Shares learnings from audits and inspections with study team. Identifies and ensures resolution of potential risks based on previous study/systems QC results, audit and inspection results."},
            {dec: "Works with LMs to ensure the training compliance within function"},
            {dec: "Identifies and organises/provides on-going and ad hoc training to Clinical Operation staff according to training needs",
            addition: [
              "introductory training to new staff, including Procedural Training",
              "ad hoc local training solutions e.g. as result of serious or recurring quality issues",
              "(be involved in) other initiatives to identify and share best practices",
            ]
            },
            {dec: "Identifies opportunities for quality improvement and optimizing/simplifying relevant processes"},
            {dec: "Provides training to Investigational Site staff on GCP, ICH and local regulations, if support needed by local study team"},
            {dec: "Creates an environment of strong team spirit, timely and effective communications, sense of urgency, high motivation and inspires teams to achieve goals in the immediate and long term. To be an active and visible change agent, promoting flexible and open mindsets to new opportunities. "},
            {dec: "Role model and embed performance driven culture"},
            {dec: "Recruit Quality Manager Personnel"},
            {dec: "Provide performance management, performance assessment and reward proposals for direct reports"},
            {dec: "Ensures compliance to ethics, policies and standard procedures"},
          ],
          requirement: [
            {dec: "University degree (or equivalent), preferably in medical or biological sciences or discipline associated with clinical research. Advanced degree is preferred."},
            {dec: "At least 10 or more years' experience from within the pharmaceutical industry or similar organization or academic experience.  "},
            {dec: "Procedural Documents generating experience."},
            {dec: "Experience with Quality Management Systems "},
            {dec: "Good understanding of the drug development process and related GXP activities"},
            {dec: "Good understanding of the skills and knowledge required for the successful delivery of a clinical study, eg. ICH-GCP, study management, site management, monitoring and local regulations"},
            {dec: "Good knowledge of local and international regulations and guidelines"},
            {dec: "Ability to monitor the internal and external working environment and enable changes to drive quality, simplification and efficiency"},
            {dec: "Ability to look for and champion more efficient and effective methods/processes of delivering quality clinical trials with reduced budget and in less time."},
            {dec: "Excellent written and verbal communication skills"},
            {dec: "Excellent ability to priorities and handle multiple tasks"},
            {dec: "Good analytical, problem solving, negotiation and conflict resolution skills."},
            {dec: "Demonstrated ability to set and manage priorities, performance targets and project initiatives in a global environment"},
            {dec: "Strong interpersonal skills, with the ability to work effectively with others at all levels of the organization"},
            {dec: "Excellent cultural awareness."},
            {dec: "Integrity and high ethical standards"},
            {dec: "Proven leadership promoting motivation and empowerment to others in order to accomplish individual, team and Dizal objectives"},
            {dec: "Agility- Quickly act with an open mind to face internal and external transformation"},
            {dec: "Come up with innovative ideas to respond to changing markets"},
          ] 
        }, 

        // Global Study Leader
        {
          name: 'Global Study Leader',
          loLocation: 'Shanghai/Beijing',
          roleResponsibility: [
            {dec: "Lead and coordinate a cross functional team to operationally deliver defined clinical studies, via a team of contributing experts from the study synopsis (where applicable) to the final clinical study report and archived master file. to time, cost and quality standards."},
            {dec: "Lead and facilitate communication across all functions and provide guidance to the study team members when required and in accordance with study-specific communication plan,"},
            {dec: "Provide input into study feasibility, protocol synopsis and/ development of essential documents such as clinical study protocol through to Clinical study report (CSR) in collaboration with medical scientist and/study physician according to relevant company SOPs."},
            {dec: "When working across studies or project work package ensures consistency across the development program. "},
            {dec: "Work closely with Quality Management & Quality Assurance to review audit findings and implement effective corrective action plans."},
            {dec: "Ensure all Third Party Vendors (i.e central laboratories, IxRS etc) engaged at study level are performing to contracted goals and timelines/budget and that adequate oversight is documented."},
            {dec: "For outsourced studies, be the primary Dizal point of contact for the CRO Project managers to ensure study delivery according to agreed timelines, budget and quality standards, while ensuring appropriate level of oversight of the CRO is maintained and documented throughout the lifecycle of the study, in accordance with relevant company SOPs, or CRO SOPs as pre-defined in the SOW agreements (where applicable) and transfer of obligations."},
            {dec: "Lead/contribute to clinical submission assembly, regulatory response and payer evidence teams and contributes to advisory board and steering committee meetings. "},
            {dec: "Accountable for Management of initial budget estimate, changes to project scope and costs (including CRO and other partners change orders). "},
            {dec: "Oversee study level performance against agreed milestones, plans, responsible for reporting project status include any risks to timelines and/quality along with proposed mitigations to senior leadership and generation of status reports as required. "},
            {dec: "Accountable for agreeing with the project team and functions the most efficient procedures to support delivery by taking the project situation and compliance requirements into account."},
            {dec: "Develop and maintain at a minimum relevant study plans/tools such as Visible planning, Risk management & contingency plan, Q&A log, Issue, Decision & Action log, Communication plan, Quality Control plan ensuring that the issue escalation pathways are clear to the entire study team."},
            {dec: "Identify and report quality issues along with corrective and preventive actions to senior leadership esp. when its related to any data privacy, serious breaches and/impact to the reputation of company and safeguard patients' rights and wellbeing."},
            {dec: "Oversee TMF completion at all times and that all QC activities are all performed as agreed."},
            {dec: "Ensure studies are always inspection ready, according to ICH-GCP, company SOPs and relevant regulatory requirements."},
            {dec: "Provide input towards process improvements."},
            {dec: "If need arises, manages staff, providing coaching and work direction. Conducts regular performance appraisals and career discussions with staff. Facilitates employee career development. Interviews and selects staff."},
          ],
          requirement: [
            {dec: "University degree (or equivalent), preferably in medical or biological sciences or discipline associated with clinical research. Advanced degree is preferred."},
            {dec: "At least 8 years' experience in clinical operation with 3 ~ 5 years' experience as Project manager or leading role working in a global environment and/global studies from within the pharmaceutical industry or similar organization or academic experience. "},
            {dec: "Extensive knowledge of clinical research regulatory requirements, clinical operations, project management and processes"},
            {dec: "Good experience of clinical development / drug development process in various phases of development and therapy areas."},
            {dec: "Project management certification is desirable but not mandatory."},
            {dec: "Evidence of developing partnering skills"},
            {dec: "Strategic and critical thinking abilities "},
            {dec: "Strong problem-solving skills "},
            {dec: "Ability to learn and Passion to develop team members"},
          ]
        },
        // Sr. Clinical Research Associate
        {
          name: '(Sr.) Clinical Research Associate',
          loLocation: 'Across China',
          roleResponsibility: [{
              dec: "Be responsible for the delivery of the studies at allocated sites and works in close collaboration with other CRAs and the local study delivery team to ensure that quality and quantity commitments are achieved in a timely and efficient manner.",
              addition: [],
            },
            {
              dec: "Conduct site feasibility assessment.",
              addition: [],
            },
            {
              dec: "Contribute to the selection of potential investigators and leading investigator.",
              addition: [],
            },
            {
              dec: "Contribute to national Investigator meeting.",
              addition: [],
            },
            {
              dec: "Obtain and maintain essential documentation in compliance with GCP, ICH-GCP, Company documents and local regulations both in the office and at site.",
              addition: [],
            },
            {
              dec: "Actively participate in local Study Team meetings.",
              addition: [],
            },
            {
              dec: "Train, support and advice Investigators and site staff in study related matters.",
              addition: [],
            },
            {
              dec: "Initiate, monitor and close study sites in compliance with Company Documents. Share information on patient recruitment and study site progress within local Study Team.",
              addition: [],
            },
            {
              dec: "Drive performance at the sites.",
              addition: [],
            },
            {
              dec: "Update study related systems with data from sites per required timelines.",
              addition: [],
            },
            {
              dec: "Manage study supplies, drug supplies and drug accountability at study sites.",
              addition: [],
            },
            {
              dec: "Perform source data verification. Proactively identify study-related issues and escalates as appropriate.",
              addition: [],
            },
            {
              dec: "Complete monitoring visit reports within required timelines. Document the issues and follow up with sites until it is resolved.",
              addition: [],
            },
            {
              dec: "Ensure accurate and timely reporting of Serious Adverse Events.",
              addition: [],
            },
            {
              dec: "Work with data management to ensure quality of the study data. Ensure data query resolution.",
              addition: [],
            },
            {
              dec: "Prepare for activities associated with audit and regulatory inspection at responsible sites in liaison with local study team lead and QA.",
              addition: [],
            },
            {
              dec: "Ensure compliance with company policies and procedures relating to people, finance, technology, security and SHE (Safety, Health and Environment).",
              addition: [],
            },

          ],
          requirement: [{
              dec: "University degree in related discipline, preferably in life science, or equivalent qualification.",
              addition: [],
            },
            {
              dec: "At least 2-years clinical research working experience in multinational pharmaceutical companies or multinational CROs is preferred.",
              addition: [],
            },
            {
              dec: "Fluent knowledge of spoken, read and written English.",
              addition: [],
            },
            {
              dec: "Excellent knowledge of international guidelines ICH/GCP.",
              addition: [],
            },
            {
              dec: "Good knowledge of relevant local regulations.",
              addition: [],
            },
            {
              dec: "Good medical knowledge and basic understanding of the drug development process.",
              addition: [],
            },
            {
              dec: "Good understanding of Clinical Study Management including monitoring, study drug handling and data management.",
              addition: [],
            },
            {
              dec: "Ability to travel nationally as required.",
              addition: [],
            },

          ]
        },
        // Data Management Project Leader
        {
          name: 'Data Management Project Leader',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {
              dec: "Serves as the expert in Clinical Research Data Management (DM) to provide oversight and advice to the clinical study team(s) regarding the DM activities and deliverables",
              addition: ["Manages and resolves issues related to DM deliverables by developing solutions to complex problems to ensure consistency across organization",
              "Provides input to the DM related activities associated with regulatory inspections/audits",
              "Provide DM business expertise and consultancy in the selection and use of software systems and vendors",],
            },
            {
              dec: "Contribute to DM processes and standards .",
              addition: ["Ensure the quality and consistency with company strategies and standards across therapeutic areas",
              "Provide input into collection standards and processes based on industry best practices",
              "May be asked to provide strategic DM expertise to company Clinical Initiatives",],
            },
            {
              dec: "Management and oversight of vendor contracts, resourcing and budgets",
              addition: ["Reviews, assesses and manages DM delivery against KPIs and overall DM performance",
              "Provides input into the contract process for the Data Management ",
              "Manages all Data Management timelines and DM Deliverables for assigned studies",],
            },
            {
              dec: "Operational Responsibilities",
              addition: ["Accountable for the execution and overall quality of DM activities and deliverables. ",
              "Acts as the single point of contact for all data management for the study team during the study set-up phase, accountable for the CRF design, DB specifications (including edit checks, CRF working instructions, etc.), during study conduct, and study close-out activities.",
              "Provide guidance and supervision to Lead Data Managers working on the study (CRO or in-house) and coordinate the data analysis team for on-time deliverables.",
              "Accountable for “Real Time Data Management” (RTDM), ensuring that DM conducts initial reviews within 5 days (or agreed timeline) of a patient’s data entering the EDC system, and manages the average query aging to no more than 20 days (or agreed timeline).",
              "Accountable for the overall quality and completeness of the Data Management Plan (DMP) and the Data Quality Plan (DQP).",],
            },
            {dec: "Provide input and/lead towards process improvements if necessary. "},
            {dec: "Identify and report quality issues along with corrective and preventive actions to senior leadership esp when its related to any data privacy, serious breaches and/impact to the reputation of company and safeguard patients’ rights and wellbeing."},
            {dec: "Oversee TMF completion at all times and that all QC activities are all performed as agreed for data management."},
            {dec: "Ensure studies are inspection ready at all times by closing working with cross functional teams, according to ICH-GCP, company SOPs and relevant regulatory requirements."},
          ],
          requirement: [
            {
              dec: "Education",
              addition: ["Minimum of a BS in life sciences or computer science degree ",],
            },
            {
              dec: "Experience",
              addition: ["Strong Data Management experience in the Biotech/Pharma/CRO industry",],
            },
            {
              dec: "Special Skills/Abilities",
              addition: ["Demonstrated knowledge of clinical and pharmaceutical drug development process ",
              "Demonstrated current understanding of GCP and regulatory requirements as they relate to data management systems and activities",
              "Demonstrated current understanding of Good Clinical Data Management Practices (GCDMP)",
              "State of the art understanding of database structures, data standards (CDISC) and practices as they apply to CRF design, database development, data handling and reporting",
              "Be familiar with the “End to End” concept from protocol development to CSR generation",
              "Experience of clinical databases, different clinical data management systems and electronic data capture (EDC)",
              "Demonstrated understanding of clinical data system design / development / validation and system interoperability.",
              "Demonstrated leadership (including in an outsourced environment)",
              "Excellent understanding and demonstration of the DZ values and behaviours ",
              "Demonstrated project management skills",
              "Strong communication and interpersonal skills",
              "Excellent organizational and analytical skills",
              "Ability to work independently",
              "Demonstrated ability to work effectively with external partners",
              "Ability to negotiate and influence others across functional areas",
              "Excellent written and verbal communication skills",
              "Effective problem and conflict solving skills",
              "Ability to work in a global team environment",
              "Ability to interact effectively with all levels of management",
              "High attention to detail and accuracy",],
            },
          ] 
        },  
        // Lead Data Manager
        {
          name: 'Lead Data Manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Be responsible to create the main DM documents for EDC set up, including to not limited to"},
            {dec: "The study Rave build specification (RBS) based on the study RDS (Raw data specification) and study protocol."},
            {dec: "Visit Matrix"},
            {dec: "Edit check specification"},
            {dec: "CRF Completion Guidance"},
            {dec: "Coding associated document"},
            {dec: "Manual data review specification"},
            {dec: "Lead the study specific testing of EDC during the study set up stage and database amendment process. "},
            {dec: "Draft Data Management Plan under the guidance of DMPL. "},
            {dec: "Work with DB programmer and external vendor on the external data transfer specification. "},
            {dec: "Be responsible of routine data management activities e.g. EDC user account management, DM status report, local lab management, DM documentation filing, etc. "},
            {dec: "Lead the data validation process in the study and ensure the DM activities to be on track, which includes but not limited to external data reconciliation, SAE reconciliation, coding, etc.  "},
            {dec: "Perform quality control of the data validation done by DM throughout the study. "},
            {dec: "Collaborate with CRA to analyse the data issue trend at site and then support on the systematic data issue solution. "},
            {dec: "Coordinate the medical data review process and manage the stakeholders of medical data review."},
            {dec: "Proactively identify the risk of data validation and work out the mitigation plan. "},
            {dec: "Organize the data validation activities and create the data cleaning plan to fit the study needs. "},
            {dec: "Generate the Data Management Report (DMR) in China submitted study. "},
            {dec: "Contribute on the functional initiative to streamline the process and improve the efficiency."},
          ],
          requirement: [
            {dec: "Master degree or Bachelor degree in medical or pharmacy related major"},
            {dec: "2-3 years of independent experience of Lead DM"},
            {dec: "Good knowledge of clinical trial and GCP and regulatory requirement in terms of data management systems and activities"},
            {dec: "Fluent English skill"},
            {dec: "Proactive communication with others"},
            {dec: "Can do attitude"},
            {dec: "Good presentation skill"},
            {dec: "Certificated SCDM is preferred"},
          ] 
        },  
        // Data Manager
        {
          name: 'Data Manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {
              dec: "Be responsible to execute activities in Study set up, including but not limited to",
              addition: ["Review the key study documents, e.g. study protocol, Rave build specification, Edit check specification, Data Management plan, etc. ",
              "Perform the User Acceptance Testing (UAT) ",
              "Work with LDM in the process of Manual data review specification and External Data Transfer specification, etc. ",],
            },
            {
              dec: "Be responsible to perform the data validation activities throughout the study life cycle, including but not limited to",
              addition: ["Query management",
              "Manual data review",
              "SAE reconciliation",
              "External data reconciliation",],
            },
            {dec: "Master the data management filing requirement and be responsible to upload the DM documents into eTMF system on timely manner with good quality."},
            {
              dec: "Support LDM on the activities to",
              addition: ["Collaborate with CRA to analyse the data issue trend at site and then support on the systematic data issue solution. ",
              "Coordinate the medical data review process and manage the stakeholders of medical data review.",
              "Proactively identify the risk of data validation and work out the mitigation plan. ",
              "Provide the study DM status report in the appropriate approach. ",],
            },
            {dec: "Gain the knowledge of Dizal Clinical Data Standards and work on the relevant activities as necessary. "},
            {dec: "Proactively identify the process gap and contribute on the process streamline task. "},
            {dec: "Be capable to work on the activity which is authorized by LDM and proactively identify the risk of the delegation and provide the proposal as necessary. "},
          ],
          requirement: [
            {
              dec: "Education",
              addition: ["Master degree or Bachelor degree in medical or pharmacy related major"],
            },
            {
              dec: "Experience",
              addition: ["2-3 years of independent experience of DM",
              "Good knowledge of clinical trial and GCP and regulatory requirement in terms of data management systems and activities",],
            },
            {
              dec: "Special Skills/Abilities",
              addition: ["Fluent English skill",
              "Proactive communication with others",
              "Can do attitude",
              "Open mind to learn new things",
              "Certificated SCDM is preferred",],
            },
          ] 
        },  
      ]
    },
    // CMC
    {
      department: 'Chemistry Manufacturing & Control',
      long_d: true,
      list: [
        // API (Sr.) Scientist
        {
          name: 'API (Sr.) Scientific Manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Lead and manage multiple projects simultaneously, allocate resources and coordinate project activities to facilitate the achievements of major milestones of projects to ensure required deliveries on time."},
            {dec: "Define targeted delivery, key milestone & task with timeline, and manage budget forecast accordingly."},
            {dec: "Perform synthetic route design and scouting for the purpose of process R&D of API & related compounds through both internal lab work and collaboration with CRO/CDMO."},
            {dec: "(SM/AD) Actively engage in all CMC API/RSM projects, identify weak points and introduce new chemistry/process to solve issues and improve process maturity."},
            {dec: "(SM/AD) Proactively communicate with Medchem team to have in-depth understanding of pre-CDID project."},
            {dec: "(SM/AD) Clearly & proactively define team expectations, communicate project progress and needs, and interface with analytical, engineering, technical service, process development groups (both internal & external) to function as one team."},
            {dec: "(SM/AD) Lead Dizal lab design & expansion work."},
            {dec: "Take part in up-scaling and OOS/OOT/deviation investigation and trouble shooting in a timely manner."},
            {dec: "Take part in the compilation of regulatory package and know-how documentation."},
            {dec: "Maintains professional skills/knowledge by keeping abreast of literature, regulations, and guidelines."},
            {dec: "Supervises scientific personnel as appropriate to the effective operation of the research team."},
            {dec: "Proactively participates in team activities as an excellent team player, contributes to project deliveries."},
          ],
          requirement: [
            {dec: "A Ph.D. degree in organic or medicinal chemistry with >= 6 years of experience (including postdoctoral studies) in synthetic route design & scouting and process R&D in small molecule API (NCE) within pharmaceuticals, with exposure to late phase development is a plus."},
            {dec: "A proven track record in taking ownership of chemistry/process problems and developing safe & elegant routes/solutions is a fundamental requirement."},
            {dec: "Experience in leading a technical team and initiating and managing external partner activity is essential, and experience of the manufacturing environment is a plus."},
            {dec: "Hands-on work in lab and/or travel to external partner is expected."},
          ] 
        },
        {
          name: 'Sr. Formulation Engineer',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Serve as formulation lead of new drug development projects and provide technical expertise on formulation and process development/optimization. Lead, plan and execute product transfer, PSB/PPQ/PAI/launch campaigns readiness. "},
            {dec: "Interface with CDMOs, suppliers, and internal clients. Efficiently communicate with different functional stakeholders to align the work priority and the production timeline."},
            {dec: "Design and review experimental protocols independently or with CDMOs. Conduct formulation and process development of conventional and enabling formulations with quality risk assessment approach, and quality by design (QbD) concept."},
            {dec: "Manage all GMP manufacturing activities including clinical, registrational, and validation batches at CMO or internal sites."},
            {dec: "Write and edit pharmaceutical and formulation development report to be included in NDA CMC dossiers."},
            {dec: "Join QA audits to qualify potential CDMOs from process perspectives. Prepare for Pre-Approval Inspection (PAI) leading to NDA approval."},            
          ],
          requirement: [
            {dec: "BS/MS minimal of 5 years industrial experiences, Pharmaceutical/Chemical Engineering or related scientific fields with minimal of 5 years of industrial experience."},
            {dec: "Hands on experience in drug product formulation design and development, process development, and pilot and large-scale manufacturing, for NDA and/or ANDA launches."},
            {dec: "Experience in process unit operation including encapsulation, tablet compression, dry granulation, high shear wet granulation, fluid bed granulation, and coating."},
            {dec: "Experience in experimental design and reviewing of manufacturing/packaging/labeling batch records."},
            {dec: "Experience in enabling formulations e.g. spray dry dispersion, hot melt extrusion, nano formulation, lipid-based emulsion formulation, as well as controlled release formulations is a plus."},
            {dec: "Familiar with production equipment from pilot to commercial scales. The work experience in drug product factory is the plus. Experience on CPV / tech transfer / process & cleaning validation / Six sigma & Statistics is preferred. "},
            {dec: "Experience on pharmaceutics and pharmacokinetics (DMPK) are preferred. "},
            {dec: "Familiar with compliance requirements for formulation or process changes during development."},
            {dec: "Fluent in oral and written English. Good organization and presentation skills"},
          ] 
        },
      ]
     },
     {
      department: 'Quality, ARD & CMCRA',
      list: [
        {
          name: 'Quality Assurance - GMP',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Manage QA aspects to CMO for API and DP production, testing and distribution, to ensure Dizal as MAH to assure product quality & safety. Included but not limited as: "},
            {dec: "Act as representative between Dizal's QA department and Dizal's contract manufacturers and testing laboratories "},
            {dec: "Oversight of development and approval of quality test methods for release and stability testing of company's drug substances and drug products. "},
            {dec: "Provide quality support for quality issues and investigations, CAPA, change management, complaints, validation documents review and approval, and batch release. "},
            {dec: "Responsible for supplier quality lifecycle management and oversight, including performing supplier audit, negotiating Quality Agreement, quality performance review and improvements, to ensure compliance with Dizal's quality system for contract manufacturing organizations."},
            {dec: "Ensure CMOs are compliance ready for regulatory inspections and monitor progress during inspections.  "},
            {dec: "Lead quality section transfer of API & DP technology to selected new CMOs, ensure necessary knowledge and experience be well exchanged."},
            {dec: "Provide QA review of NDA submission CMC part."},
          ],
          requirement: [
            {dec: "Minimal Bachelor's degree in relevant technical or scientific fields, Chemistry or Biology preferred. "},
            {dec: "Minimum 5 years of experience working in production, QA and QC functions in pharmaceutical industry include API and finished Product manufacturing."},
            {dec: "Experience on CMO management, MAH quality management and QP experience is a plus."},
            {dec: "Knowledge of risk assessment, problem solving and negotiating skills. "},
            {dec: "Ability to work independently with cross functional scientific/technical personnel."},
            {dec: "Must be willing to travel approximately 5 - 10%.."},
          ] 
        },
        {
          name: 'CMC Regulatory Affairs Senior Manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Regulatory Submission:",
              addition: [
                "Coordinate CMC each function to prepare CMC related IND packages, amendment, DSUR/annual report, and NDA dossiers to meet local legislation and regulatory policies",
                "Track CMC changes and develop/communicate amendment plan ",
                "Develop regulatory submission plans in conjunction with key stakeholders to achieve rapid approval for clinical studies, deliver high quality approval and facilitate rapid launch for responsible projects ",
                "Track status and take prompt corrective measures whenever necessary ",
                "Ensure all submission documents are appropriately archived",
                "Coordinate Clinical Trial Registration for allocated projects ",
              ]
            },
            {dec: "Regulatory Strategy:",
            addition: [
              "Develop regulatory compliance strategies to accommodate CMC changes during clinical development",
              "Ensure information sharing and consistency of approach in regulatory advice and awareness across the department and teams",
              ]
            },
            {dec: "Regulatory Intelligence:",
            addition: [
              "Monitor and understand the impacts of external changes in the regulatory and policies environment specifically in CMC area that will impact on the assigned products",
              "Keep tracking and comparison of evolution of global regulatory science",
              "Communicate the impact of changes to key stakeholders",
            ]
            },
            {dec: "Others",
              addition: [
              "Develop internal SOP as needed",
              "Develop junior CMC specialists.",
            ]
            },
          ],
          requirement: [
            {dec: "Academic / Professional qualification",
            addition: [
              "Minimal Bachelor's degree on medical, pharmacy, pharmacology, biochemistry, or chemistry Master or PhD is plus",
            ]},
            {dec: "Technical / skills training    ",
            addition: [
            "Possess a high degree of honesty with a track record built on success stories and sound ethics, have a proven track record from a pharmaceutical company",
            "Fully understand the current regulatory practices and regulation in CMC area",
            "With tract record on successful NDA filings for major markets, e.g. US and category 1 products in China",
            "Strong ability on building solid trust partnerships among peers",
            "Excellent verbal and written communication skills and good enough English, fluent in English reading/writing/listening/speaking.",
            "Able to work with a keen sense of urgency and priority",
            "Good project management skill and experience",
            ]},
              {dec: "Essential",
              addition: [
              "Extensive regulatory experiences, minimum 3-year related working experiences in CMC function of pharmaceutical company",
              "Experience with CMC Regulatory affairs ",
            ]},
              {dec: "Desirable",
              addition: [
              "Language ability",
              "Good verbal and written communication skills in both Chinese and English",
            ]},
              {dec: "Computer literacy",
              addition: [
              "Good at PC skills on Word, Excel, PowerPoint, Outlook, MS Project",
            ]},
          ] 
        },
        {
          name: 'Quality Compliance - GMP',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Establish and maintain the Quality Systems & Compliance program to ensure the applicable GMP and MAH regulatory compliant with supporting product development to commercial manufacturing."},
            {dec: "建立，维护和管理质量体系及合规程序，确保满足适应的GMP及MAH相关法规的要求，支持产品开发及商业化生产。"},
            {dec: "Submit and maintain Manufacturing License as MAH, initiate and maintain close contacts with regulatory agencies, communicate with local health authority, support product registration related activities."},
            {dec: "申请和维护药品上市许可人相关的药品生产许可证，负责和当地药政部门的沟通和联系，协助产品上市注册的相关事宜。"},
            {dec: "Manage the execution of regulatory inspections, internal and external audits, including inspection readiness activities, performing internal and external audit, ensuring timely preparation of responses to observations, follow-up and closure."},
            {dec: "管理法规检查和内、外审计流程，包括检查的准备活动，执行内外部审计，确保及时准备对审核发现项的回复，跟踪及关闭。"},
            {dec: "Establish and execute of the self-inspection program. Ensure the program drives continuous improvement of the quality systems and processes."},
            {dec: "建立并执行内审/自检程序，确保内审程序能够驱动质量体系和流程的持续改进。"},
            {dec: "Establish and maintain a GMP training system. Responsible for personnel training, including new employee GMP training, continuous and refresh training, regulatory compliance and audit training and quality process training."},
            {dec: "创建并维护GMP培训体系，负责人员培训，包括GMP新员工培训，持续培训，法规和审计培训和质量流程培训。"},
            {dec: "Responsible for quality metrics/performance review and reporting, lead and organize quality improvement project to ensure that quality initiatives are executed and maintained in compliance with GMP requirements."},
            {dec: "负责质量绩效回顾和报告，领导和组织质量持续改进项目，确保质量措施的执行和保持符合GMP要求。"},
            {dec: "Support PAI and GMP inspection readiness program, NDA filing documents and product launch compliance activities （including establishment of GSP QMS, if necessary）."},
            {dec: "支持PAI和GMP检查准备，NDA递交和产品上市合规活动（包括必要的GSP质量体系建立）。"},
            {dec: "Maintain and continuously improve GMP compliance system, build up compliance continuous improvement plan and facilitate implementation."},
            {dec: "维护和持续改进GMP符合性体系，建立符合性持续改进计划并推动实施。"},
            {dec: "Mange the emerging regulations and systematic evaluation of new requirements, educate employees around new requirements, compliance trends."},
            {dec: "负责管理新法规，对新要求进行系统的评估，对员工进行新要求和合规趋势的培训。"},
            {dec: "Responsible for GMP Document Management and ensure its effectiveness and continuous improvement."},
            {dec: "负责GMP文件管理，确保文件系统的有效实施和持续改善。"},          
          ],
          requirement: [
            {dec: "Minimal Bachelor’s degree in Pharmacy, Biology, Chemistry, or related fields."},
            {dec: "至少本科或以上学历，药学，生物学，化学或相关专业"},
            {dec: "Minimum 5 years of experience working in pharmaceutical or biotechnology industry experience in a quality and GMP area."},
            {dec: "5年以上制药或生物技术行业在质量及GMP领域工作经验。"},
            {dec: "Comprehensive knowledge of regulatory agency interactions and compliance procedures, with ability to apply the knowledge in an operations environment and promote process improvement continuously."},
            {dec: "熟悉药品法规和符合性要求，并能运用在实际工作中，推进持续改进。"},
            {dec: "Solid knowledge of quality systems, audit or inspection management, risk assessment, and other evolving principles across the global compliance area."},
            {dec: "掌握质量体系、审计技能、风险评估、以及全球合规领域其他不断发展的原则。"},
            {dec: "Good communication skills, strong quality minds and strong service minds."},
            {dec: "良好的沟通技巧，强烈的质量观念和服务意识。"},
            {dec: "Continuously invest time and effort to gain new skills and knowledge required to succeed in the work."},
            {dec: "持续的学习能力获得新的知识或技巧以胜任工作的要求。"},
            {dec: "Good English and Computer skill."},
            {dec: "英语水平良好，电脑使用熟练。"},
          ] 
        },
      ]
    },
    {
      department: 'Commercial',
      list: [
        {
          name: '(Senior) Product Manager ',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Develop business action plan, work closely with internal multi-functions and external agencies to ensure high quality execution of promotion programs"},
            {dec: "Develop brand promotional materials and conduct product related training"},
            {
              dec: "Support to develop brand plan",
              addition: [
                "Collect, analyse and monitor market intelligence including market dynamic, competitor information etc.",
                "Gain market and customer insight through promotion programs, customer visit and relevant market research programs "
              ]
            },
            {dec: "Marketing expense phasing and control"},
          ],
          requirement: [
            {dec: "Bachelor or above, science background preferred"},
            {dec: "Solid experience in marketing programs development and execution, with commercial insight"},
            {dec: "Good analytical skill and experience in marketing strategy development"},
            {dec: "Quick learner, passionate, self-motivated and customer orientated"},
            {dec: "CMKT experience over 2 years"},
          ]
        },
        {
          name: '(Sr.) KA Manager',
          loLocation: 'Across China',
          roleResponsibility: [
            {dec: "Develop and sustain strategic partnership and long-term collaboration with key hospitals' stakeholders"},
            {dec: "Engage key pharmacists in collaboration with Dizal to drive NRDL listing"},
            {dec: "Work closely with internal multi-functions and external agencies/HCOs to ensure high quality execution of access activities/programs"},
            {dec: "Drive the achievement of access objectives in target hospitals, including hospital bidding, listing, price management, purchasing, and smooth implementation of NRDL at hospital level"},
            {dec: "Deliver key messages related with products, company brands, new drug development, clinical research, etc. on regular base to target customer"},
        ],
          requirement: [
            {dec: "Bachelor or above, science background preferred"},
            {dec: "More than 5 years experiences from pharmaceutical company with background associated with Oncology and/or other specialty medicine products management"},
            {dec: "Solid experience with hospital listing and key account management"},
            {dec: "Advanced negotiation skill and a good influencer"},
            {dec: "Result oriented, able to work under high pressure and manage multiple tasks effectively"},
        ]
        },
        {
          name: '(Sr.) Business planning manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Lead a wide range of commercial planning projects to address critical business problems via data research, analysis, and insight generation"},
            {dec: "Develop commercial strategy and implement roadmap across all commercial teams and ensure the strategic plans are in line with the company’s overall objectives"},
            {dec: "Work seamlessly with all company and commercial functions and coordinate important cross team projects"},
            {dec: "Organize both internal and external discussions, develop materials, manage key stakeholders / vendors, monitor budget, etc."},
        ],
          requirement: [
            {dec: "Bachelor degree and above, preferably in medical, pharmaceutical, or other analytical degrees"},
            {dec: "At least 3 years' work experience in Consulting firm or Pharmaceutical industry, preferably experienced in strategic planning, new product planning, business development."},
            {dec: "Deep knowledge of oncology/hematology disease is a plus"},
        ]
        },
        {
          name: '(Sr.) Commercial Manager',
          loLocation: 'Across China',
          roleResponsibility: [
            {dec: "Evaluate potential distributors and build solid network to support new product launch and maximize the coverage"},
            {dec: "Negotiate key contract terms with distributor, while sustaining strong distributor relationships"},
            {dec: "Responsible for bidding management including price management, online purchasing and on records procurement, etc."},
            {dec: "Optimize Tier 1 and Tier 2 distributor management including warehouse, goods delivery, inventory, billing and funding flow"},
            {dec: "Engage distributors in collaboration with the Company for market access programs to support NRDL listing"},
        ],
          requirement: [
            {dec: "Bachelor or above, marketing, business administration background preferred"},
            {dec: "More than 5 years experiences from pharmaceutical company with background associated with Oncology and/or other specialty medicine products management"},
            {dec: "Solid experience with regional commercial channel management"},
            {dec: "Advanced negotiation skill and a good influencer"},
            {dec: "Able to work under high pressure and manage multiple tasks effectively"},
            {dec: "Result oriented and able to work under pressure "},
        ]
        },
        {
          name: '(Senior) Training Manager ',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Working with BU, Market Access to diagnose and analyze of training needs"},
            {dec: "Provide sales force development solutions to enhance the sales organization capabilities."},
            {dec: "Develop and implement a standardized training concept and plan for new hires."},
            {dec: "Make training plan, develop relevant training materials and organize training."},
            {dec: "Evaluate training effectiveness and collect feedbacks to continuously improve training quality."},
            {dec: "Collaborate with IT, digital team to develop online course"},
            {dec: "Other tasks assigned by supervisor"},
          ],
          requirement: [
            {dec: "Bachelor degree and above, preferably in pharmaceutical, business management, marketing or other analytical degrees"},
            {dec: "4-5 years sales training experience in MNC pharmaceutical company, with course design experience is a plus"},
            {dec: "At least 1 year sales management experience at DSM or higher level"},
            {dec: "Good skills in communication, moderation, coaching, mentoring, and project management."},
            {dec: "Ability of designing customized training programs"},
            {dec: "Strong facilitation skill"},
            {dec: "Able to work under pressure"},
            {dec: "Ready to travel"},
          ]
        },
        {
          name: 'Medical Science Liaison',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {
              dec: "Medical information communication",
              addition: [
                "To communicate directly and proactively scientific information on the products within the approved label as well as information related to the therapeutic area to KOLs and broader external audiences, including participation in formulary discussions as appropriate.",
                "Handle unsolicited medical inquiries of customers for approved products and products/indications in development, based on literatures, safety records, scientific FAQs etc. ",
                "To provide medical and product training and scientific support to Sales Representatives in coordination with Training Department as appropriate.",
                "Create standard response documents and maintain updated medical and scientific knowledge about clinical practices and studies conducted within the therapeutic areas to internal stakeholders.",
              ]
            },
            {
              dec: "Medicinal education, medical program/activities plan and execution",
              addition: [
                "To organize local or regional medical education activities including program development, speaker selection and on-site meeting etc.",
                "Support medical affairs program and activities at local and regional level.",
                "Responsible for exhaustive collection of information from the in-scope territory regarding existing knowledge gaps, scientific data gaps and clinical care gaps.",
              ]
            },
            {
              dec: "KOL development and engagement",
              addition: [
                "Actively identify, develop and engage key KOLs at regional level.",
                "Through scientific interactions with KOLs, champion medical benefits of products and contribute to foster innovative therapeutic approaches to benefit patients.",
                "Coordination on IIT submission, review and feedback process",
              ]
            },
          ],
          requirement: [
            {dec: "Medical science, pharmacology with at least Master degree, Medical Doctor or PharmaD preferred."},
            {dec: "Deep knowledge of the therapeutic area, strength in research and interpretation of medical data."},
            {dec: "Strong influence skills and communication skills to establish and maintain partnership with KOLs and other key stakeholders."},
            {dec: "MSL, MI, CRA, PV or related medical service working experience, or talented high-potential graduate."},
            {dec: "Good command of English, fluent at writing, speaking and listening."},
          ]
        },
        {
          name: 'Area Marketing Manager',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Work with both central marketing and sales team to organize company activities and programs."},
            {dec: "Coordinate external customer events following brand strategy."},
            {dec: "Catch marketing insights and develop into regional marketing strategy and tactics planning."},
            {dec: "Build mutually beneficial relationships with regional stakeholders."},
            {dec: "Cooperate with sales team to achieve/exceed sales target under company's code of conduct."},
            {dec: "Build brand cooperation with regional KOLs, collect market information on unmet customer needs, KOL feedbacks, competitor information etc for further analysis and better understanding of the area market insights"},
            {dec: "Integrate and leverage medical, marketing and market access resources to ensure the effective achievement of business objectives."},
            {dec: "Report to sales director with updated business progress and market information."},
        ],
          requirement: [
            {dec: "Bachelor's degree or above, science background preferred"},
            {dec: "Demonstrated experience in people management and overachievement of sales target"},
            {dec: "Minimum 3 years of sales management experience and 1 years of local marketing experience"},
            {dec: "Strong execution mindset"},
            {dec: "Outstanding communication& interpersonal skills"},
        ]
        },
        {
          name: 'Regional Sales Manager',
          loLocation: 'Across China',
          roleResponsibility: [
            {dec: "Lead a regional sales team to deliver/exceed sales target of the region"},
            {dec: "Set short to long term business objectives for the region aligning with overall commercial goals"},
            {dec: "Build mutually beneficial relationships with regional stakeholders"},
            {dec: "Achieve/exceed sales target under company's code of conduct"},
            {dec: "Develop and execute regional sales action plan based on understand of regional market potential/hospital segment/key stakeholders/competitors etc."},
            {dec: "Report to sales director with updated business progress and market information"},
            {dec: "Build and manage a high-performing sales team with reasonable turn-over rate"},
            {dec: "Expense management on par with budget"},
        ],
          requirement: [
            {dec: "Bachelor's degree or above, science background preferred"},
            {dec: "Demonstrated experience in people management and overachievement of sales target"},
            {dec: "5 years' and or above sales experience with increasing responsibility"},
        ]
        },
        {
          name: 'District Sales Manager',
          loLocation: 'Across China',
          roleResponsibility: [
            {dec: "Responsible for the sales plan execution of a defined area to achieve/exceed sales target, leading a team of sales representatives"},
            {dec: "Key hospitals/key customers management to build strong business partnership"},
            {dec: "Collect and consolidate HCPs’ feedback to sales leaders"},
            {dec: "Achieve/exceed sales target under company's code of conduct"},
            {dec: "Develop and execute territory level action plan"},
            {dec: "Effectively coach and develop sales representatives on professional knowledge and soft skills"},
            {dec: "Key stakeholder engagement"},
        ],
          requirement: [
            {
              dec: "Education, Qualification, Work Experience",
              addition: [
                "Bachelor's degree or above in computer science, information management, or equivalent work experience.",
                "More than 5 years' experience of commercial solution and application delivery in pharmaceutical enterprise.",
                "Strong in at least one of PowerBI, FineBI, ClickView, Tableau, and Business Object.",
                "Strong in Java/J2EE, and Spring framework, MyBatis, Oracle, MySQL, SQL Server, and NoSQL experience.",
                "Experience in Python, HTML/H5, JavaScript, CSS, ECharts, D3.",
                "Strong in informatica, or kettle ETL tools etc.",
                "Own experience of WeChat or mobile app development.",
                "Advanced skills in project management, PMP certificate is plus.",
                "Strong communications and teamwork kills, working in a global environment.",
                "Good English speaking and writing skills.",
              ]
            },
            {
              dec: "Skills",
              addition: [
                "Strong analytic and problem solving abilities.",
                "Quick learning skills.",
                "Ability to work on Agile teams.",
                "Ability to work on multiple projects concurrently.",
                "Ability to work in a team environment and be a team player.",
              ]
            },
        ]
        },
      ]
    },
    // Operation
    {
      department: 'Operation',
      list: [
      // Digital Solution Lead
      {
        name: 'Digital Solution Lead',
        loLocation: 'Shanghai',
        roleResponsibility: [
          {dec: "Build CRM, Master data system for commercial teams"},
          {dec: "Responsible for commercialization process management, performance management, E-commerce sales order system development, SAP ERP integration."},
          {dec: "Build an enterprise data warehouse, business intelligence, integrate sales data, performance data, and build dashboard."},
          {dec: "Develop WeChat Mini Programs and Mobile Android and IOS APPs for commercial Business."},
          {dec: "Responsible for the writing of relevant documents and SOP."},
          {dec: "Customize and deliver ad-hoc solution based on commercial need."},
          {dec: "Drive on-time delivery of IT projects within the constraints of time, approved spend, scope, and quality."},
          {dec: "Establish strong project management and plans to support the business case."},
          {dec: "Effectively manage communications with stakeholders and other project teams."},
          {dec: "Develop system based on designs and specifications, and utilizing standards, procedures, and techniques."},
          {dec: "Identify information technology trends and explore opportunities for use within the organization"},
        ],
        requirement: [
          {dec: "At least 3-year experience of GLP toxicity studies in CRO or Pharma"},
          {dec: "Familiar with CFDA/ICH/OECD Guidelines"},
          {dec: "Master degree in toxicology, pharmacology, or other related fields"},
          {dec: "Good written and oral English"},
          {dec: "Good team spirit"},
        ]
      },
      ]
    }, 
  ],
  campusList: [
    // Clinical Development
    {
      department: 'Clinical Development',
      list: [
        {
          name: 'Medical Scientist 临床研究助理医师 ',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Work closely with physician for clinical development plan (including protocols) for Dizal projects"},
            {dec: "Support physician to conduct successful clinical studies with all in-scope integrity (i.e., providing medical monitoring)"},
            {dec: "Provide science review and analysis to support physician shaping clinical study design and product strategy "},
            {dec: "Co-owners of clinical study delivery "},
            {dec: "Work closely with physician for development documents (CIB, protocol and CSR, etc.) "},
            {dec: "Work closely with physician to analyse and interpret clinical study results in partnership with other development functions"},
            {dec: "Work closely with physician to form and run advisory board meeting; Be responsible for interacting and communicating with KOLs for development strategy and protocol design "},
            {dec: "Support regulatory filing and registration "},
            {dec: "Provide consultation to clinical operation colleagues on protocol design questions and answer protocol related questions from site investigators"},
        ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Medical Related 临床医学专业",
              "Ph.D Degree 医学博士",
              ]
            },
            {dec: "General disease Knowledge"},
            {dec: "General compound knowledge "},
            {dec: "General Regulatory knowledge"},
            {dec: "Investigator & site knowledge"},
            {dec: "Medical monitoring"},
            {dec: "Safety monitoring and evaluation of signals"},
            {dec: "CSP/CSR content & data analysis"},
            {dec: "Presentation & communication skill"},
            {dec: "Clinical trial landscape and competitive intelligences"},
          ]
        },
        {
          name: 'Clinical Pharmacologist 临床药理助理研究员',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Execute scientifically robust and efficient clinical pharmacology strategies for NME and/or development candidates, working together with senior members."},
            {dec: "Contribute to overall compound development via application of quantitative methods to integrate knowledge of PK, PD, patient characteristics, disease states, and drug-drug interactions to optimize dose selection, dosage regimens and study designs throughout drug development. "},
            {dec: "Provide the clinical pharmacokinetics and pharmacodynamics expertise and support required for Investigator Brochures, Clinical Trials Applications, Marketing Applications, regulatory meetings, and responses to regulatory questions."},
            {dec: "Work effectively in matrix environment, managing ClinPharm deliverables in accordance with timelines and overall project goals."},
        ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Clinical Pharmacology, Medical Related 临床药理及医学相关专业",
              "Ph.D 博士研究生",
              ]
            },
            {dec: "Willingness to Acknowledge Areas for Growth: Understands need for growth and is receptive to constructive feedback."},
            {dec: "Detail-Oriented: Follows precise procedures and demonstrates thoroughness in performing job tasks and assignments."},
            {dec: "Communication Skills: The ability to convey both written and verbal information effectively and efficiently. "},
            {dec: "Fluent in spoken English and good in written"},
          ]
        },{
          name: 'PV Operation Associate Generalist 药物警戒运营专员',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "Conduct, coordinate and/or supervise all PV activities in clinical trials to ensure regulatory compliance, including but not limited to PV vendor management, contributing to preparation and submission of expedited safety reports, preparation and review of safety related documents, collaborating on project issue identification and resolution. 进行、协调和/或监督临床试验中的所有药物警戒相关活动，以确保合规性，包括但不限于药物警戒供应商管理，准备和提交安全报告，支持安全相关文件的准备和审查，协助识别和解决项目问题。"},
            {dec: "Ensure collection and reporting of product safety events in post-marketing settings in good quality and in compliance with governing laws and legislations from various sources, e.g., spontaneously from HCP and consumers, literatures, product complaint, social media, regulatory authorities, organized data collection programs, etc. 确保在上市后环境中从各来源收集和报告高质量的产品安全事件，并符合相关的法律和法规要求，例如，来自医务人员和消费者的自发报告、文献、产品投诉、社交媒体、监管机构、有组织的数据收集项目等。"},
            {dec: "Support preparation and submission of aggregated safety reports, e.g., DSUR, PUSR/PEBRE, etc.支持汇总安全报告的准备和提交，如DSUR、PUSR/PEBRE 等。 "},
            {dec: "Support the submission of risk management plans according to applicable legislations, directives, guidance, etc., and participant in risk communication and implementation of risk minimization measures.按照相关法律、法规、指南等文件的要求，支持风险管理计划计划的递交，参与风险的沟通，风险最小化措施的实施等工作。"},
            {dec: "Support internal and external PV audits or inspection.支持内部和外部 药物警戒 审计或检查。"},
            {dec: "Perform PV trainings to relevant personnel according to the safety activities assigned. 根据分配的项目及活动，对相关人员进行药物警戒相关培训。"},
            {dec: "Interface with business partners as needed in accordance with applicable pharmacovigilance agreements.根据适用的药物警戒协议，根据需要与商业合作伙伴联系。"},
            {dec: "Support PV head on the PV capability establishment, including but not limited to the PV procedure and SOPs establishment, etc.支持药物警戒负责人建立药物警戒职能，包括但不限于药物警戒流程和标准化操作流程的建立等。"},
          ],
          requirement: [
            {dec: "Bachelor’s level degree or above in life sciences, pharmacy, nursing or medical生命科学，药学，护理或医学等相关专业本科以上学历，"},
            {dec: "Excellent organizational skills, learning skills and ability to prioritize and multi-task出色的组织能力、学习能力以及优先处理和多任务处理能力"},
            {dec: "Excellent communication and interpersonal skills  出色的沟通和人际交往能力"},
            {dec: "Fluent in English (writing and speaking) 英语流利（写作和口语）"},
          ]
        },
      ]
    },
    // Clinical Operations
    {
      department: 'Clinical Operations',
      list: [
        {
          name: 'Clinical Research Associate Trainee 临床监查员',
          loLocation: 'Shanghai & Beijing',
          roleResponsibility: [
            {dec: "Be responsible for the delivery of the studies at allocated sites and works in close collaboration with other CRAs and the local study team to ensure that quality commitments are achieved in a timely and efficient manner.  "},
            {dec: "Conduct site feasibility assessment."},
            {dec: "Contribute to the selection of potential investigators and leading investigator. "},
            {dec: "Contribute to national Investigator meeting. "},
            {dec: "Obtain and maintain essential documentation in compliance with international guidelines ICH-GCP, Company procedural documents and local regulations both in the office and at site."},
            {dec: "Actively participate in local Study Team meetings. Share information on patient recruitment and study site progress within local Study Team. Good knowledge in relevant Therapeutic area to train, support and advice Investigators and site staff in study related matters."},
            {dec: "Initiate monitor and close study sites in compliance with Company procedural Documents.  Ensures compliance with protocols, regulatory requirements, and good clinical practices; writes follow-up visit reports."},
            {dec: "Drive performance at the sites. "},
            {dec: "Update study related systems with data from sites per required timelines."},
            {dec: "Manage study supplies, drug supplies and drug accountability at study sites."},
            {dec: "Perform source data verification. Proactively identify study-related issues and escalates as appropriate."},
            {dec: "Complete monitoring visit reports within required timelines. Document the issues and follow up with sites until it is resolved. "},
            {dec: "Ensure accurate and timely reporting of Serious Adverse Events."},
            {dec: "Work with data management to ensure quality of the study data. Ensure data query resolution."},
            {dec: "Prepare for activities associated with audit and regulatory inspection at responsible sites and/country in liaison with local study team lead and QA."},
            {dec: "Ensure compliance with company policies and procedures relating to people, finance, technology, security and SHE (Safety, Health and Environment)."},
            {dec: "Ability to understand the impact of technology on projects and to use and develop computer skills while making appropriate use of systems/software"},
            {dec: "Responsible for completeness and timeliness of the eTMF to maintain it “Inspection Ready”."},
            {dec: "Identify and report quality issues along with corrective and preventive actions to Local study leader/equivalent esp when its related to any data privacy, serious breaches and/impact to the reputation of company and safeguard patients' rights and wellbeing."}
        ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Pharmacy & Medical Related 药学，医学相关专业",
              "Master 硕士研究生",
              ]
            },
            {dec: "Good medical knowledge and basic understanding of the drug development process."},
            {dec: "Fluent knowledge of spoken, read and written English. "},
            {dec: "Team oriented and flexible. Ability to manage & prioritize multiple tasks with conflicting deadlinesAbility to work in an environment of remote collaborators"},
            {dec: "Meticulous and detail-oriented"},
            {dec: "Ability to travel nationally as required.  "},
          ]
        },
        {
          name: 'Clinical Trial Assistant 临床试验助理',
          loLocation: 'Shanghai & Beijing',
          roleResponsibility: [
            {dec: "Contribute to clinical study start-up, execution, close-out and reporting at country and/or site level."},
            {dec: "Assist local study team with preparation, handling, distribution, filing and archiving of clinical documentation and reports according to company policies and SOPs. "},
            {dec: "Maintain Trial Master File (TMF) at country and/or site level per the scope of work. Assist with periodic review of study files for completeness. Preparation for relevant QC checks when applicable. "},
            {dec: "Track site compliance and performance per study timelines via Clinical Systems (e.g. eTMF, CTMS, EDC, IRT system). "},
            {dec: "Manage, coordinate, and track study materials, equipment and cost at country and/or site level. Track site budget related matters, including processing invoices, tracking payments, updating relevant trackers, coordinating the translation of required documents. "},
            {dec: "Lead the practical arrangements and contribute to the preparation of internal and external meetings e.g. local study team meetings, monitor meetings, Investigator meetings. Liaise with internal and external participants and/or vendors at country and/or site level. "},
            {dec: "Coordinate administrative tasks during the study process, audits and regulatory inspections, according to company policies and SOPs. "},
            {dec: "Provide input into non-drug project work including training activities, meeting events and development of work instructions as needed. "},
            {dec: "If needs arise, may support CRAs for on-site visits to assist with clinical monitoring duties upon completion of required trainings and with required approval. May perform assigned administrative tasks at study level. "},
            {dec: "Ensure compliance with company policies and procedures relating to people, finance, technology, security and SHE (Safety, Health and Environment)."},
            {dec: "Ability to understand the impact of technology on projects and to use and develop computer skills while making appropriate use of systems/software"},
            {dec: "Identify and report quality issues along with corrective and preventive actions to Local study leader/equivalent esp when its related to any data privacy, serious breaches and/impact to the reputation of company and safeguard patients' rights and wellbeing."}
        ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Pharmacy & Medical Related 药学，医学相关专业",
              "Bachelor and Above 本科及以上",
              ]
            },
            {dec: "Level of education that supports Skills and Capabilities of the position and ensures successful conduct of accountabilities/responsibilities and appropriate interactions with internal/external customers "},
            {dec: "Ability to develop advanced computer skills to increase efficiency in day-to-day tasks"},
            {dec: "Good verbal and written communication and presentation skills"},
            {dec: "work accurately, being proactive, independent and working in a team"},
            {dec: "Ability to prioritise and manage multiple tasks with conflicting deadlines"},
            {dec: "Good interpersonal skills and ability to work in a team environment"},
            {dec: "Willingness to travel both domestically and internationally"},
            {dec: "Proactively identify risks and possible solutions"},
            {dec: "Ability to prepare presentation materials "},
            {dec: "Demonstrate professionalism and mutual respect "},
            {dec: "Willingness and ability to train others on study administration procedures"},
            {dec: "Display excellent organization and time management skills, "},
            {dec: "Computer proficiency"},
            {dec: "Good knowledge of spoken and written English"},
          ]
        },
        {
          name: 'Data Management Trainee 临床数据管理',
          loLocation: 'Beijing',
          roleResponsibility: [
            {
              dec: "Be responsible to execute activities in Study set up, including but not limited to ",
              addition: [
                "Review the key study documents, e.g. study protocol, Rave build specification, Edit check specification, Data Management plan, etc. ",
                "Perform the User Acceptance Testing (UAT) ",
                "Work with LDM in the process of Manual data review specification and External Data Transfer specification, etc. ",
              ]
            },
            {
              dec: "Be responsible to perform the data validation activities throughout the study life cycle, including but not limited to",
              addition: [
                "Query management",
                "Manual data review",
                "SAE reconciliation",
                "External data reconciliation",
              ]
            },
            {dec: "Master the data management filing requirement and be responsible to upload the DM documents into eTMF system on timely manner with good quality. "},
            {
              dec: "Support LDM on the activities to",
              addition: [
                "Collaborate with CRA to analyse the data issue trend at site and then support on the systematic data issue solution. ",
                "Coordinate the medical data review process and manage the stakeholders of medical data review.",
                "Proactively identify the risk of data validation and work out the mitigation plan. ",
                "Provide the study DM status report in the appropriate approach. ",
              ]
            },
            {dec: "Gain the knowledge of Dizal Clinical Data Standards and work on the relevant activities as necessary. "},
            {dec: "Proactively identify the process gap and contribute on the process streamline task. "},
            {dec: "Be capable to work on the activity which is authorized by LDM and proactively identify the risk of the delegation and provide the proposal as necessary. "}
        ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Pharmacy & Medical Related 药学，医学相关专业",
              "Master 硕士研究生",
              ]
            },
            {dec: "Fluent English skill"},
            {dec: "Proactive communication with others"},
            {dec: "Can do attitude"},
            {dec: "Open mind to learn new things"},
          ]
        },
      ]
    },
    // Finance
    {
      department: 'Finance',
      list: [
        {
          name: 'Accountant 财务会计',
          loLocation: 'Shanghai',
          roleResponsibility: [
            {dec: "RMB and foreign currency payment arrangement and process and be the main contact with banks."},
            {dec: "Bank journal posting in time."},
            {dec: "Monthly bank account balance reconciliation."},
            {dec: "Cash management."},
            {dec: "Prepare Cash Flow budget and Cash Flow report."},
            {dec: "Voucher scan, collation, and filing."},
            {dec: "Other ad hoc projects and tasks as assigned."}
          ],
          requirement: [
            {
              dec: "Education",
              addition: [
              "Finance 财务相关专业",
              "Bachelor 本科",
              ]
            },
            {dec: "Solid basic accounting knowledge. Accounting related certificate is a plus."},
            {dec: "Good communication skills, initiative and sense of responsibilities, ability to work under pressure."},
            {dec: "Be good at Microsoft software, especially excel."},
            {dec: "Good English in both oral and written."},
          ]
        }
      ]
    },
    {
      department: '商业化',
      long_d : false,
      list: [
        {
          name: '医药代表预备队',
          loLocation: '全国',
          roleResponsibility: [
            {dec: "执行公司市场部产品推广计划和方案，完成及超越公司的销售指标；"},
            {dec: "熟练掌握公司及产品，并且相关领域疾病、竞品知识，熟练并能独立组织幻灯演讲，向医学专业人士传递正确的产品信息或者最新医、药学资讯；"},
            {dec: "有效的将目标客户进行分级管理，合理安排拜访频率，传递正确的产品信息；"},
            {dec: "相关数据的及时维护和更新，准确并及时的反馈市场信息"},
            {dec: "协助主管完成招标和医保相关事务"},
          ],
          requirement: [
            {dec: "2023届本科及以上学历，医药及生命科学相关专业优先考虑；"},
            {dec: "有很高的从事医药销售推广的意愿；"},
            {dec: "较强的业务敏锐度，解决问题的能力，客户沟通能力，有较强的观察、学习与运用能力，很好的执行力"},
            {dec: "不畏艰难与挑战，坚持不懈的追求成功与卓越；"},
            {dec: "良好的品格，坚决遵守国家和公司的相关法规、条例。"},
            {dec: "备注：需要参加6个月的实习培训，培训结束后通过考核予以录用"},
          ]
        }
      ]
    }
  ]
};
const getters = {
  getJobsList: state => {
    return state.jobsList;
  },
  getJobByDepartmentAndJob: (state, job) => (job) => {
    // console.log(job.dep, ':', job.name)
    for (let index in state.jobsList) {
      if (state.jobsList[index].department == job.dep) {
        let departmentList = state.jobsList[index].list;
        for (let index1 in departmentList) {
          if (departmentList[index1].name == job.name) {
            return departmentList[index1];
          }
        }
      }
    }
  },
  getCampusList: state => {
    return state.campusList;
  },
  getCampusByDepartmentAndJob: (state, job) => (job) => {
    // console.log(job.dep, ':', job.name)
    for (let index in state.campusList) {
      if (state.campusList[index].department == job.dep) {
        let departmentList = state.campusList[index].list;
        for (let index1 in departmentList) {
          if (departmentList[index1].name == job.name) {
            return departmentList[index1];
          }
        }
      }
    }
  }
};
const mutations = {};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js